import { Directive, Input,  } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { 
  IntraTvaCheckerResult, 
  SearchSuppliersParameters, 
  PS_Search_Suppliers_Result, 
  Supplier,
  Country,PafSetting
} from '../all-models';
import { 
  SuppliersService,
  SharedDataService, 
  InputCheckersService 
} from '../all-services';


@Directive({
  selector: '[intraTvaValidator]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, useExisting: IntraTvaValidatorDirective, multi:
      true
  }]
})
export class IntraTvaValidatorDirective  implements AsyncValidator {
  constructor(
    private suppliersSvc:SuppliersService,
    private inputCheckerSvc: InputCheckersService,
    public sharedDataSvc: SharedDataService) { 
    }


  get excludedCountries():string[]
  {
    return (this.sharedDataSvc.pafSettings.find((ps:PafSetting)=>ps.KEY=='TVA_VIES/EXCLUDED_COUNTRY_CODES').VALUE || '').split(';');
  }

  // Soit Country, soit CountryCod2, soit Supplier soit rien et pas de test sur le pays
  @Input() intraTvaValidator?: Supplier | Country | string | undefined= undefined;

  
  get CountryCod():string | undefined {
    if (!this.intraTvaValidator) return undefined;
    if ((typeof this.intraTvaValidator) == 'string' ) return <string>this.intraTvaValidator;
    if (!!(<any>this.intraTvaValidator).CountryCod2 ) return <string>(<any>this.intraTvaValidator).CountryCod2;
    return (<Supplier>this.intraTvaValidator).SupplierAgencies.find(a=>a.IsSupplierAgency==1)?.Agency?.Address?.Country?.CountryCod2;
  }
  
  validate(control: AbstractControl):  Observable<ValidationErrors> | Promise<ValidationErrors> {
    let numIntraTva : string = (<string>control.value || '').replace(/\s/g, '');
    if ((numIntraTva||'')=='') {
      return of(null)
    };
    if (!!this.CountryCod && this.excludedCountries.indexOf(this.CountryCod)>=0) return of (null);
    return this.inputCheckerSvc.IntraTvaCheck(numIntraTva)
      .pipe(
        map((result: IntraTvaCheckerResult) => {
            if (!result|| !result.isValid) {
              return {'IntraTvaInvalide': 'IntraTva_invalide'};
            } else {
              numIntraTva = result.CountryCode+result.VatNumber;
              if ((<string>control.value)!=numIntraTva) {
                control.setValue(numIntraTva,{onlySelf: true, emitEvent:true, emitModelToViewChange:true, emitViewToModelChange: true});
              }
              return null;
            }
        }
        ),
        catchError((err:any)=>of({'IntraTvaInvalide': 'IntraTva_invalide'}))
     );
  }
  registerOnValidatorChange?(fn: () => void): void {}
}


@Directive({
  selector: '[intraTvaWarning]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, useExisting: IntraTvaWarningDirective, multi:
      true
  }]
})
export class IntraTvaWarningDirective  implements AsyncValidator {
  constructor(
    private suppliersSvc:SuppliersService,
    private inputCheckerSvc: InputCheckersService,
    public sharedDataSvc: SharedDataService) { }

  validate(control: AbstractControl):  Observable<ValidationErrors> | Promise<ValidationErrors> {
    let numIntraTva : string = (<string>control.value || '').replace(/\s/g, '');
    if ((numIntraTva||'')=='') {
      return of(null)
    };
    return this.inputCheckerSvc.IntraTvaCheck(numIntraTva)
      .pipe(
        map((result: IntraTvaCheckerResult) => {
            if (!result|| !result.isValid) {
              return {'intraTvaWarning': 'IntraTva_invalide'};
            } else {
              numIntraTva = result.CountryCode+result.VatNumber;
              if ((<string>control.value)!=numIntraTva) {
                control.setValue(numIntraTva,{onlySelf: true, emitEvent:true, emitModelToViewChange:true, emitViewToModelChange: true});
              }
              return null;
            }
        }
        ),
        catchError((err:any)=>of({'intraTvaWarning': 'IntraTva_invalide'}))
     );
  }
  registerOnValidatorChange?(fn: () => void): void {}
}



@Directive({
  selector: '[intraTvaUnique]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, useExisting: intraTvaUniqueDirective, multi:
      true
  }]
})
export class intraTvaUniqueDirective  implements AsyncValidator {
  @Input() intraTvaUnique?:any = null;
  constructor(
    private suppliersSvc:SuppliersService,
    public sharedDataSvc: SharedDataService) { }

  validate(control: AbstractControl):  Observable<ValidationErrors> | Promise<ValidationErrors> {
    let numIntraTva : string = (<string>control.value || '').replace(/\s/g, '');
    if ((numIntraTva||'')=='') {
      return of(null)
    };
    if (numIntraTva.substring(0,2)=='FR'){
      if (this.sharedDataSvc.debug) console.log(`intraTva validator : doublons autorisés pour FR`);
    return of(null);
    }
    let parameters : SearchSuppliersParameters = new SearchSuppliersParameters();
    parameters.UniqueId = numIntraTva;
    let search : Observable<PS_Search_Suppliers_Result[]>  = this.suppliersSvc.getSuppliers(parameters);
    return search.pipe(map((result:PS_Search_Suppliers_Result[])=>{
      let doublon : PS_Search_Suppliers_Result = result.find(r=>r.Id!=(<number>this.intraTvaUnique||0));
      if (doublon) {
        return {'intraTvaUnique': doublon};        
      } else {
        return null;
      }
    }));
  }
  registerOnValidatorChange?(fn: () => void): void {
    
  }

}

